import React from 'react';
import { TFunction } from 'i18next';
import { MemberType } from '../../../../types/api/MemberType';
import { RequestManagement } from './RequestManagement';
import Btn from '../../Btn';
import { MemberRowMode } from '../MemberRowTypes';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { Icons } from '../../../atoms/SVG';
import { ButtonRefType } from '../../Btn/Btn';

type MemberActionsType = {
  mode?: MemberRowMode | null;
  member: MemberType;
  editButtonRef: ButtonRefType;
  removeButtonRef: ButtonRefType;
  changeOrToggleMode: (modeObj: MemberRowMode | null) => void;
  t: TFunction;
};

/**
 * Renders the interaction triggers (modes)
 */
export function MemberActions({
  mode,
  member,
  editButtonRef,
  removeButtonRef,
  changeOrToggleMode,
  t,
}: MemberActionsType) {
  const requestIsPending = member.rolesWithStatus.find(({ status }) => status === 'requestPending');

  if (requestIsPending) {
    return <RequestManagement approveForm={member.actions.approveRequest} rejectForm={member.actions.rejectRequest} />;
  }

  return (
    <>
      {member.actions.editRoles && (
        <Btn
          text={t('status.editRoles.button', { name: member.profileLink.name })}
          titleText={t('status.editRoles.button', { name: member.profileLink.name })}
          hiddenText
          reference={editButtonRef}
          tooltipPlacement={TooltipPlacement.TOP}
          cssClass="btn--minor-action btn--transparent"
          svgSpriteId={mode !== MemberRowMode.editRoles ? Icons.EDIT_PENCIL : Icons.DECLINE_CROSS}
          onClick={() => changeOrToggleMode(MemberRowMode.editRoles)}
        />
      )}
      {member.actions.remove && (
        <Btn
          text={t('status.remove.button', { name: member.profileLink.name })}
          titleText={t('status.remove.button', { name: member.profileLink.name })}
          hiddenText
          reference={removeButtonRef}
          tooltipPlacement={TooltipPlacement.TOP}
          cssClass="btn--minor-action btn--transparent"
          svgSpriteId={mode !== MemberRowMode.removeUser ? Icons.REMOVE_USER_CROSS : Icons.DECLINE_CROSS}
          onClick={() => changeOrToggleMode(MemberRowMode.removeUser)}
        />
      )}
    </>
  );
}
